import React from 'react'
import FieldGroupComponent from '../../components/core/FieldGroupComponent/FieldGroupComponent'
import CONFIG from '../../config/config'

import './signUpCheckboxLayout.scss'

class SignUpFormCheckboxLayout extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            acceptTerms: false,
            acceptSubscription: false,
        }
    }

    accept = () => {
        this.setState({
            acceptTerms: !this.state.acceptTerms,
            acceptSubscription: !this.state.acceptSubscription,
        })
    }

    render() {
        const { acceptTerms, acceptSubscription } = this.state
        let acceptTermsPlaceholder = `By clicking this box, I acknowledge and accept the
            <a href="` + CONFIG.termsAndConditionsURL + `" rel="noopener noreferrer" target="_blank">
            Terms of Use, the Privacy Policy</a> and agree that my information may be transferred to the U.S.`;

        if (navigator.language === 'en-US') {
            acceptTermsPlaceholder = `By clicking this box, I acknowledge and accept the
                <a href="` + CONFIG.termsAndConditionsURL + `" rel="noopener noreferrer" target="_blank">
                Terms of Use and the Privacy Policy</a>.`;
        }

        return <div className="sign-up-checkbox">
            <FieldGroupComponent
                name="acceptTerms"
                type="checkbox"
                placeholder={acceptTermsPlaceholder}
                onChange={this.accept}
                checked={acceptTerms}
            />
            <FieldGroupComponent
                name="acceptSubscription"
                type="checkbox"
                placeholder={`Accepting the <a href="https://www.lifefitness.com/en-us/legal/subscriptions/master-subscription-agreement"
                    rel="noopener noreferrer" target="_blank">Subscription Agreement</a>
                    constitutes a binding contract on you and governs your user of and
                    access to the services by you, staff and end-users whether in connection with a paid or free trial
                    subscription to the services.`}
                onChange={this.accept}
                checked={acceptSubscription}
            />
        </div>
    }
}

export default SignUpFormCheckboxLayout



// WEBPACK FOOTER //
// ./src/layouts/SignUp/SignUpFormCheckboxLayout.js